import { Button, Card, Icon } from '../ds';
import { useAuth } from '../state/AuthContext';

/**
 * Sign in.
 *
 * Both parents need to be identifiable for "who did what" to mean anything, so
 * there is no anonymous mode. Google sign-in only, for now — it is the one both
 * of you already have on your phones.
 */

export function SignInScreen({ invitedBy }: { invitedBy?: 'invite' | 'share' | null }) {
  const { signIn, status, error } = useAuth();

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 22,
        padding: '32px 22px calc(32px + env(safe-area-inset-bottom, 0px))',
        maxWidth: 520,
        margin: '0 auto',
      }}
    >
      <div>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 52,
            height: 52,
            borderRadius: 'var(--radius-lg)',
            background: 'var(--brand-subtle)',
            color: 'var(--brand)',
            marginBottom: 16,
          }}
        >
          <Icon name="House" size={26} />
        </span>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: 'var(--text-2xl)',
            margin: 0,
          }}
        >
          おうちきろく
        </h1>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-muted)', marginTop: 6 }}>
          Home — 家族でつかう記録アプリ
        </p>
      </div>

      <Card padding="md">
        <p className="cjk" style={{ fontSize: 'var(--text-sm)', color: 'var(--text-muted)', marginBottom: 16 }}>
          {invitedBy === 'share'
            ? '共有アルバムに招待されています。サインインすると写真を見られます。'
            : invitedBy === 'invite'
              ? '家族に招待されています。サインインして参加しましょう。'
              : '授乳・おむつ・ねんね、通園の準備、成長きろくを二人で分担できます。'}
        </p>

        <Button
          variant="primary"
          fullWidth
          size="lg"
          iconStart="LogIn"
          disabled={status === 'loading'}
          onClick={() => void signIn()}
        >
          Google でサインイン
        </Button>

        {error ? (
          <div
            className="cjk"
            style={{ fontSize: 'var(--text-xs)', color: 'var(--danger)', marginTop: 12 }}
          >
            {error}
          </div>
        ) : null}
      </Card>

      <p style={{ fontSize: 11, color: 'var(--text-subtle)', textAlign: 'center', lineHeight: 1.6 }}>
        記録は家族のあいだだけで共有されます。
        <br />
        <a href="/privacy.html" style={{ color: 'var(--text-link)', textDecoration: 'underline' }}>
          プライバシーポリシー · Privacy Policy
        </a>
      </p>
    </div>
  );
}
